module.exports = __webpack_public_path__ + "static/carousel-2-sm-b0c329ce8f013d4c99820735d270e267.png";